import { z } from 'zod';

const flashcardEntrySchemaV2 = z.object({
  currentIndex: z.number().nullable().default(null),
  cards: z.array(z.object({
    flipped: z.boolean()
  })).default([])
});
const flashcardEntrySchemaV1 = z.object({
  location: z.string().nullish().transform(loc => loc ? Number.parseInt(loc.replace("/", "")) : null).default(null),
  data: z.object({
    sections: z.array(z.object({
      cards: z.array(z.object({
        flipped: z.boolean()
      }))
    })).min(1).default([{
      cards: []
    }])
  })
}).transform(data => ({
  currentIndex: data.location,
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  cards: data.data.sections[0].cards
}));
const flashcardEntrySchema = z.union([flashcardEntrySchemaV2, flashcardEntrySchemaV1]);

export { flashcardEntrySchema };
//# sourceMappingURL=flashcard.entry-data.js.map
